module.exports = __webpack_public_path__ + "img/no-order.53a3e513.png";